import { render, staticRenderFns } from "./SmsVerificationModalContent.vue?vue&type=template&id=1fa6d882&"
import script from "./SmsVerificationModalContent.vue?vue&type=script&lang=js&"
export * from "./SmsVerificationModalContent.vue?vue&type=script&lang=js&"
import style0 from "./SmsVerificationModalContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports